import script from "./Element.vue?vue&type=script&setup=true&lang=js"
export * from "./Element.vue?vue&type=script&setup=true&lang=js"

import "./Element.vue?vue&type=style&index=0&id=29e8ab65&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29e8ab65"]])

export default __exports__